<div class="scan-layout">
  <router-outlet></router-outlet>
</div>

<!-- Session Timeout Dialog -->
<twx-session-timeout-dialog
  [visible]="showTimeoutDialog()"
  (continueScanning)="onContinueScanning()"
  (endSession)="onEndSessionRequested()"
/>
